function findAncestor(element, className) {
  let _element = element;
  while ((_element = _element.parentElement) && !_element.classList.contains(className))
    ;
  return _element;
}
function getContextItemIndex(options, node) {
  if (!node) {
    return -1;
  }
  return Array.from(findAncestor(node, options.parentClassName).querySelectorAll(options.elementSelector)).findIndex((element) => element === node);
}

export { getContextItemIndex };
//# sourceMappingURL=get-context-item-index.js.map
